import { defineMessages } from '@/hooks/useTranslation';

export default defineMessages({
  hero: {
    title: {
      de: 'Digitale Lösungen für dein Unternehmen',
      en: 'Digital solutions for your business'
    },
    subtitle: {
      de: ' ',
      en: ' '
    },
    description: {
      de: 'Wir vernetzen deine Systeme und automatisieren deine Prozesse',
      en: 'We connect your systems and automate your processes'
    },
    details: {
      de: 'Wir unterstützen dich bei der Digitalisierung und Automatisierung deines Unternehmens. Von ERP-Systemen und E-Commerce bis hin zu individualisierten Business-Apps und nahtlosen Schnittstellen - wir helfen dir, dein Unternehmen zukunftssicher zu machen.',
      en: 'We support you in digitalizing and automating your business. From ERP systems and e-commerce to customized business apps and seamless interfaces - we help you make your business future-proof.'
    },
    primaryCTA: {
      de: 'Entdecke unsere Lösungen',
      en: 'Discover our solutions'
    },
    secondaryCTA: {
      de: 'Beratung anfragen',
      en: 'Request consulting'
    },
    imageAlt: {
      de: 'splusd-solutions',
      en: 'splusd-solutions'
    }
  },
  references: {
    title: {
      de: 'Unsere zufriedenen Kunden',
      en: 'Our satisfied clients'
    },
    description: {
      de: 'Diese Unternehmen arbeiten mit uns zusammen',
      en: 'These companies work with us'
    },
    button: {
      de: 'Zu den Projekten',
      en: 'View Projects'
    }
  },
  services: {
    title: {
      de: 'Unsere Lösungen',
      en: 'Our Solutions'
    },
    description: {
      de: 'Wir bieten ein umfassendes Portfolio an Digitalisierungs- und Automatisierungslösungen für dein Unternehmen.',
      en: 'We offer a comprehensive portfolio of digitalization and automation solutions for your business.'
    },
    learnMore: {
      de: 'Mehr erfahren',
      en: 'Learn more'
    },
    consulting: {
      title: {
        de: 'Digitalisierungsberatung',
        en: 'Digitalization Consulting'
      },
      description: {
        de: 'Professionelle Beratung zur Optimierung deiner Geschäftsprozesse und zur Entwicklung einer maßgeschneiderten Digitalisierungsstrategie.',
        en: 'Professional consulting to optimize your business processes and develop a customized digitalization strategy.'
      }
    },
    erp: {
      title: {
        de: 'ERP-Systeme',
        en: 'ERP Systems'
      },
      description: {
        de: 'Moderne ERP-Lösungen für die effiziente Steuerung deines Unternehmens und die Optimierung deiner Prozesse.',
        en: 'Modern ERP solutions for efficient management of your business and optimization of your processes.'
      }
    },
    shopware: {
      title: {
        de: 'E-Commerce',
        en: 'E-Commerce'
      },
      description: {
        de: 'Erfolgreiche Online-Shops mit Shopware oder eigenen Plattformen, Marktplatzanbindungen und professionellem SEA-Marketing für deinen digitalen Vertrieb.',
        en: 'Successful online shops with Shopware or custom platforms, marketplace connections and professional SEA marketing for your digital sales.'
      }
    },
    businessApps: {
      title: {
        de: 'Business Apps',
        en: 'Business Apps'
      },
      description: {
        de: 'Individuelle Anwendungen für deine spezifischen Anforderungen, die deine täglichen Aufgaben effizienter gestalten.',
        en: 'Individual applications for your specific requirements that make your daily tasks more efficient.'
      }
    },
    interfaces: {
      title: {
        de: 'Schnittstellen & Integration',
        en: 'Interfaces & Integration'
      },
      description: {
        de: 'Nahtlose Vernetzung deiner verschiedenen Systeme und Anwendungen für einen reibungslosen Datenaustausch.',
        en: 'Seamless networking of your various systems and applications for smooth data exchange.'
      }
    },
    ctoService: {
      title: {
        de: 'CTO Service',
        en: 'CTO Service'
      },
      description: {
        de: 'Technische Beratung und Unterstützung bei der Entwicklung und Umsetzung deiner IT-Strategie ohne eigene IT-Führungskraft.',
        en: 'Technical consulting and support in developing and implementing your IT strategy without having your own IT executive.'
      }
    }
  },
  businessApps: {
    title: {
      de: 'Maßgeschneiderte Business Apps',
      en: 'Custom Business Apps'
    },
    description: {
      de: 'Wir entwickeln individuelle Anwendungen, die genau auf die Anforderungen und Prozesse deines Unternehmens zugeschnitten sind.',
      en: 'We develop individual applications that are tailored exactly to the requirements and processes of your company.'
    },
    benefits: {
      custom: {
        de: 'Passgenaue Lösungen für deine spezifischen Herausforderungen',
        en: 'Tailored solutions for your specific challenges'
      },
      integration: {
        de: 'Nahtlose Integration in deine bestehende IT-Landschaft',
        en: 'Seamless integration into your existing IT landscape'
      },
      automation: {
        de: 'Automatisierung von wiederkehrenden Prozessen und Aufgaben',
        en: 'Automation of recurring processes and tasks'
      }
    },
    cta: {
      de: 'Business Apps entdecken',
      en: 'Discover Business Apps'
    }
  },
  webPortals: {
    title: {
      de: 'Webportale & Self-Service',
      en: 'Web Portals & Self-Service'
    },
    description: {
      de: 'Mit unseren maßgeschneiderten Webportalen ermöglichst du deinen Kunden und Mitarbeitern einen einfachen Zugang zu wichtigen Informationen und Funktionen.',
      en: 'With our customized web portals, you give your customers and employees easy access to important information and functions.'
    },
    benefits: {
      access: {
        de: '24/7 Zugriff auf wichtige Daten und Funktionen',
        en: '24/7 access to important data and functions'
      },
      selfService: {
        de: 'Self-Service für Kunden und Partner',
        en: 'Self-service for customers and partners'
      },
      efficiency: {
        de: 'Effizienzsteigerung durch Prozessoptimierung',
        en: 'Increased efficiency through process optimization'
      }
    },
    cta: {
      de: 'Webportale entdecken',
      en: 'Discover Web Portals'
    }
  },
  ecommerce: {
    title: {
      de: 'E-Commerce & Online-Shops',
      en: 'E-Commerce & Online Shops'
    },
    description: {
      de: 'Wir helfen dir, deinen digitalen Vertrieb zu optimieren - von Shopware-Lösungen über individuelle Plattformen bis hin zur Anbindung an Marktplätze.',
      en: 'We help you optimize your digital sales - from Shopware solutions to custom platforms to marketplace connections.'
    },
    benefits: {
      shopware: {
        de: 'Professionelle Shopware-Implementierung und -Anpassung',
        en: 'Professional Shopware implementation and customization'
      },
      customPlatforms: {
        de: 'Individuelle E-Commerce-Plattformen für spezielle Anforderungen',
        en: 'Custom e-commerce platforms for special requirements'
      },
      marketplaces: {
        de: 'Anbindung an Amazon, eBay und andere Marktplätze inkl. SEA-Marketing',
        en: 'Connection to Amazon, eBay and other marketplaces incl. SEA marketing'
      }
    },
    cta: {
      de: 'E-Commerce-Lösungen entdecken',
      en: 'Discover E-Commerce Solutions'
    }
  },
  mobileApps: {
    title: {
      de: 'Mobile Apps für iOS & Android',
      en: 'Mobile Apps for iOS & Android'
    },
    description: {
      de: 'Mit unseren mobilen Anwendungen erreichst du deine Kunden und Mitarbeiter überall und jederzeit, auch unterwegs.',
      en: 'With our mobile applications, you can reach your customers and employees anywhere and anytime, even on the go.'
    },
    benefits: {
      ios: {
        de: 'Apps für iOS-Geräte',
        en: 'Apps for iOS devices'
      },
      android: {
        de: 'Apps für Android-Geräte',
        en: 'Apps for Android devices'
      },
      crossPlatform: {
        de: 'Cross-Platform-Lösungen für maximale Reichweite',
        en: 'Cross-platform solutions for maximum reach'
      }
    },
    cta: {
      de: 'Mobile Apps entdecken',
      en: 'Discover Mobile Apps'
    }
  },
  generalCta: {
    title: {
      de: 'Bereit, dein Unternehmen zu digitalisieren?',
      en: 'Ready to digitalize your business?'
    },
    description: {
      de: 'Sprich mit uns über deine Anforderungen und erfahre, wie wir dir helfen können, dein Unternehmen zukunftssicher zu machen.',
      en: 'Talk to us about your requirements and learn how we can help you make your business future-proof.'
    },
    cta: {
      de: 'Kontakt aufnehmen',
      en: 'Get in touch'
    }
  }
}); 